// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How a `Notification`'s set of banks is determined.
 *
 * LIST       (0) — the banks named by `bank_ids` (the `notification_banks`
 *                  join rows). Zero value: preserves the single-bank
 *                  behaviour of every row written before this field existed.
 * ALL_IN_ORG (1) — every bank in the notification's organization, resolved at
 *                  delivery time so banks added later are covered without
 *                  editing the rule.
 *
 * Values are APPEND-ONLY.
 */
export enum BankScope {
  LIST = 0,
  ALL_IN_ORG = 1,
}
